import React, {useEffect, useRef, useState} from 'react';

const apiKey = process.env.REACT_APP_TINYMCE_API_KEY;
let loader;

function loadTinyMce() {
  if (window.tinymce) return Promise.resolve(window.tinymce);
  if (!loader) loader = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://cdn.tiny.cloud/1/${encodeURIComponent(apiKey)}/tinymce/6/tinymce.min.js`;
    script.referrerPolicy = 'origin';
    script.async = true;
    script.onload = () => window.tinymce ? resolve(window.tinymce) : reject(new Error('Editor unavailable'));
    script.onerror = () => { script.remove(); loader = undefined; reject(new Error('Editor unavailable')); };
    document.head.appendChild(script);
  });
  return loader;
}

export default function RichTextEditor({id, name, value, onChange, disabled, placeholder, invalid, describedBy}) {
  const textarea = useRef(null);
  const editor = useRef(null);
  const [available, setAvailable] = useState(Boolean(apiKey));

  useEffect(() => {
    if (!apiKey || !textarea.current) return undefined;
    let cancelled = false;
    loadTinyMce().then(tinymce => tinymce.init({
      target: textarea.current, menubar: false, statusbar: false, height: 230,
      plugins: 'lists link', toolbar: 'undo redo | bold italic | bullist numlist | link | removeformat',
      placeholder, branding: false, promotion: false,
      setup: instance => {
        editor.current = instance;
        instance.on('input change undo redo', () => onChange({target:{name, value:instance.getContent()}}));
      }
    })).catch(() => { if (!cancelled) setAvailable(false); });
    return () => { cancelled = true; if (editor.current) { editor.current.remove(); editor.current = null; } };
  }, [name, onChange, placeholder]);

  useEffect(() => { if (editor.current && editor.current.getContent() !== value) editor.current.setContent(value || ''); }, [value]);

  if (!available) return <textarea id={id} name={name} value={value} onChange={onChange} disabled={disabled} required minLength={15} maxLength={4000} rows={6} placeholder={placeholder} aria-invalid={invalid} aria-describedby={describedBy}/>;
  return <textarea ref={textarea} id={id} name={name} defaultValue={value} disabled={disabled} aria-invalid={invalid} aria-describedby={describedBy}/>;
}
